<template>
  <el-card>
    <div id="page-panel">
      <div class="customer-top-nav">
        <div class="title">
          <span>{{$t('reports.names.'+reportCode)}}</span><br>
        </div>
        <div class="controls no-print">
           <el-switch
             v-model="expandAll"
             active-text="Développer tout"
             inactive-text=""
             @change="toggleExpandAll">
           </el-switch>
           <el-dropdown size="small" type="default" class="">
             <el-button type="primary" size="small">
               <i class="el-icon-download"></i>
             </el-button>
             <el-dropdown-menu slot="dropdown">
               <el-dropdown-item @click.native="downloadExcel"><i class="mdi mdi-file-excel"/> Excel</el-dropdown-item>
             </el-dropdown-menu>
           </el-dropdown>
           <el-button type="primary" @click="openFilterDialog" size="small"><i class="mdi mdi-filter"></i> </el-button>
           
  			</div>
      </div>

        <div class="sort-controls no-print">
          <span class="sort-label">Trier les produits par :</span>
          <el-select
            v-model="sortBy"
            size="small"
            style="width: 230px"
            placeholder="Trier par"
          >
            <el-option label="Produit (A-Z)" value="PRODUCT_NAME" />
            <el-option label="Total quantité vendue" value="TOTAL_QTY" />
            <el-option label="Nb caisses vendues" value="TOTAL_CASES" />
          </el-select>
        </div>

      <p>
        <span class="fs-14 secondary-text">{{companyName}}</span><br>
        <span class="fs-14 secondary-text">{{currentFilterPeriod}}</span><br>

      </p>
      <div id="printMe">
        <el-row>
          <el-table
            ref="productTable"
            :data="groupedProducts"
            :style="tableWidth"
            :default-expand-all="expandAll"
            empty-text="Il n'y a aucune vente pour cette période"
            class="fs-10"
            :row-style="mainRowStyle"
          >
            <el-table-column type="expand">
              <template slot-scope="props">
                <div class="expand-content">
                  <el-table
                    :data="props.row.customers"
                    size="mini"
                    border
                    class="customer-summary-table"
                  >
                    <el-table-column prop="customer_id" label="No client" width="120" />
                    <el-table-column label="Client" min-width="240">
                      <template slot-scope="customerScope">
                        <PortausLink
                          :id="customerScope.row.customer_id"
                          path="/customers/"
                          :label="customerScope.row.customer_name"
                          fs="fs-12"
                          :openNewTab="true"
                        />
                      </template>
                    </el-table-column>
                    <el-table-column label="Quantité" width="120" align="right">
                      <template slot-scope="customerScope">
                        {{ formatQty(customerScope.row.total_qty) }}
                      </template>
                    </el-table-column>
                    
                    <el-table-column label="Nb caisses" width="120" align="right">
                      <template slot-scope="customerScope">
                        {{ formatQty(customerScope.row.total_qty_9l) }}
                      </template>
                    </el-table-column>
                    
                  </el-table>
                </div>
              </template>
                  
            </el-table-column>
            <el-table-column label="Produit" min-width="260">
              <template slot-scope="scope">
                <div class="product-name">{{ scope.row.product_name }} <span v-if="scope.row.provider_name">({{ scope.row.provider_name }})</span></div>
                <div class="product-sku">{{ scope.row.sku }}</div>
                <div class="product-provider">{{ formatQty(scope.row.uvc) }} | {{ formatQty(scope.row.volume) }} ml</div>
              </template>
            </el-table-column>

            <el-table-column label="Total quantité vendue" width="180" align="right">
              <template slot-scope="scope">
                <strong>{{ formatQty(scope.row.total_qty) }}</strong>
              </template>
            </el-table-column>

            <el-table-column label="Nb caisses" width="140" align="right">
              <template slot-scope="scope">
                <strong>{{ formatQty(scope.row.total_qty_9l) }}</strong>
              </template>
            </el-table-column>

          </el-table>
        </el-row>
      </div>
    <reportFilter v-if="!loading"
                  :visible="reportFilterVisible"
                  @close="closeFilterDialog"
                  :predefinedPeriod="predefinedPeriod"
                  :period="period"
                  :startDate="this.filters.startDate"
                  :endDate="this.filters.endDate"
                  :customerFilter="true"
                  :customer="selectedCustomer"
                  :providerFilter="true"
                  :provider="selectedProvider"
                  :reps="salesRep"
                  :selectedReps="getUserById(filters.reps)"
                  :customer_classes="customerClasses"
                  :selectedCustomerClasses="filters.customer_classes"
                  :productFilter="true"
                  :selectedProduct="this.filters.product"
                  @applyFilter="handleFilter">
    </reportFilter>
    <WatingDialog :visible="loading || toggleLoading" content="Veuillez patienter pendant que nous préparons votre rapport. Cela peut prendre plusieurs secondes."></WatingDialog>
    <el-button 
      v-if="showScrollTop" 
      @click="scrollToTop" 
      class="scroll-to-top-btn"
      type="primary" 
      icon="el-icon-arrow-up" 
      circle>
    </el-button>
</div>
<!-- </el-row> -->
</el-card>
</template>
<script>
//import Section
import salesAPI from '@/services/API/sales.js'
import systemAPI from '@/services/API/system.js'
import moment from 'moment'
import XLSX from 'xlsx'
import { saveAs } from 'file-saver'
// import { extendMoment } from 'moment-range';
// const moment = extendMoment(Moment);
import reportFilter from './report-filter'
import reportUtil from '@/utils/report-util.js'
import { mapActions, mapState, mapGetters } from 'vuex';
import * as echarts from 'echarts';
import Promise from "bluebird";
import WatingDialog from '@/components/waiting-dialog'
import PortausLink from '@/components/portaus-link'

export default {
  name : "Sales-report",
  props : {
    width : {
      type : Number,
      default : 100
    },
    fiscalEndDay : Number,
    fiscalEndMonth : Number,
    lastFiscalYearDate : Object,
    fiscalYearDate : Object,
    month : Object,
    lastMonth : Object,
    companyName : '',
  },
  data() {
    return {
      data : [],
      loading: true,
      filters : {
        range : 'MONTH',
        startDate : null,
        endDate : null,
        statuses : [],
        customerId : null,
        providerId: null,
        reps : [],
        products : [],
      },
      reportFilterVisible : false,
      expandAll: true,
      showZeroTotalCases: false,
      appliedShowZeroTotalCases: false,
      toggleLoading: false,
      showScrollTop: false,
      scrollHandler: null,
      sortBy: 'PRODUCT_NAME',
    };
  },
  components : {
    reportFilter,
    WatingDialog,
    PortausLink
  },
  watch: {

  },
  computed : {
    selectedCustomer(){
      if(this.filters.customerId!=null && this.filters.customerId!=undefined){
        return {id:this.filters.customerId}
      }else{
        return null;
      }
    },
    selectedProvider(){
      if(this.filters.providerId!=null && this.filters.providerId!=undefined){
        return {id:this.filters.providerId}
      }else{
        return null;
      }
    },
    predefinedPeriod(){
      if(this.fiscalYearDate.startDate!=null && this.fiscalYearDate.endDate!=null){
        return [
          {code : 'MONTH', description:this.month.startDate.format('DD MMM YYYY') + '-'+this.month.endDate.format('DD MMM YYYY')},
          {code : 'LAST_MONTH', description:this.lastMonth.startDate.format('DD MMM YYYY') + '-'+this.lastMonth.endDate.format('DD MMM YYYY')},
          {code : 'LAST_12_MONTHS', description: moment().subtract(11, 'months').startOf('month').format('DD MMM YYYY') + ' - ' + moment().endOf('month').format('DD MMM YYYY')},
          {code : 'FISCAL_YEAR',description:this.fiscalYearDate.startDate.format('DD MMM YYYY') + '-'+this.fiscalYearDate.endDate.format('DD MMM YYYY')},
          {code : 'LAST_FISCAL_YEAR',description:this.lastFiscalYearDate.startDate.format('DD MMM YYYY') + '-'+this.lastFiscalYearDate.endDate.format('DD MMM YYYY')},
          {code : 'CUSTOM', range:true}
        ]
      }else{
        return [];
      }

    },
    tableWidth(){
      return 'width : ' + this.width + 'px;';
    },
    currentFilterPeriod(){
      return reportUtil.currentFilterPeriod(this.fiscalYearDate,this.lastFiscalYearDate,this.filters.range,this.filters.startDate,this.filters.endDate )
    },
    reportCode(){
      return this.$route.params.code;
    },
    period(){
      return _.find(this.predefinedPeriod, p=>{return p.code==this.filters.range})
    },
    groupedProducts() {
      if (!Array.isArray(this.data)) return [];

      const eligibleRows = this.data.filter(row => this.hasEligibleStatusWeight(row));
      const byProduct = _.groupBy(eligibleRows, row => row.product_id);
      const products = _.map(byProduct, rows => {
        const first = rows[0] || {};
        const customers = rows
          .map(r => ({
            customer_id: r.customer_id,
            customer_name: r.customer_name,
            total_qty: Number(r.total_qty || 0),
            total_qty_9l: Number(r.total_qty_9l || 0),
          }))
          .sort((a, b) => b.total_qty - a.total_qty);

        const total_qty = _.sumBy(customers, c => c.total_qty);
        const total_qty_9l = _.sumBy(customers, c => c.total_qty_9l);

        return {
          product_id: first.product_id,
          product_name: first.product_name,
          sku: first.sku,
          provider_name: first.provider_name,
          uvc: Number(first.uvc || 0),
          format: first.format,
          volume: Number(first.volume || 0),
          total_qty,
          total_qty_9l,
          customers,
        };
      });

      const sortedProducts = _.orderBy(
        products,
        [
          (p) => {
            if (this.sortBy === 'TOTAL_QTY') return Number(p.total_qty || 0);
            if (this.sortBy === 'TOTAL_CASES') return Number(p.total_qty_9l || 0);
            return _.deburr(p.product_name || '').toLowerCase();
          },
          (p) => _.deburr(p.product_name || '').toLowerCase(),
        ],
        [this.sortBy === 'PRODUCT_NAME' ? 'asc' : 'desc', 'asc']
      );

      if (this.appliedShowZeroTotalCases) return sortedProducts;
      return sortedProducts.filter(p => Number(p.total_qty || 0) > 0);
    },
    salesRep(){
      return this.filterUserWithRoleRep;
    },
    ...mapState('inventory',['inventories']),
    ...mapGetters('users',['filterUserWithRoleRep', 'getUserById']),
    ...mapState('controlData',['customerClasses']),
    ...mapGetters(['isStrictFilteredByRep', 'isCurrentUserRep', 'getCurrentUserId', 'isCurrentUserAdmin']),

  },
  methods : {
    hasEligibleStatusWeight(row) {
      const rawWeight = _.get(row, 'status.weight', _.get(row, 'status_weight', _.get(row, 'weight', null)));

      // If API does not expose status weight for this report, keep backward-compatible behavior.
      if (rawWeight == null || rawWeight === '') return true;

      const weight = Number(rawWeight);
      if (Number.isNaN(weight)) return true;

      return weight >= 10;
    },
    mainRowStyle() {
      return { backgroundColor: '#f2f2f2' };
    },
    toggleExpandAll(value) {
      this.groupedProducts.forEach(row => {
        this.$refs.productTable.toggleRowExpansion(row, value);
      });
    },
    handleFilter(filters){
      localStorage.sales_range = filters.period != null ? filters.period.code : 'MONTH';

      if (filters.period != null && filters.period.code === 'CUSTOM' && filters.dateRange != null && filters.dateRange.length === 2) {
        localStorage.sales_startDate = filters.dateRange[0];
        localStorage.sales_endDate = filters.dateRange[1];
      }

      let inventories = [];
      _.forEach(filters.inventories, m=>{
        inventories.push(m.id);
      })
      localStorage.sales_inventories = JSON.stringify(inventories);
      
      localStorage.sales_customerId = filters.customer!=null ? filters.customer.id : undefined;
      localStorage.sales_providerId = filters.provider!=null ? filters.provider.id : undefined;
      let reps = [];
      _.forEach(filters.reps, m=>{
        reps.push(m.id);
      })
      localStorage.sales_reps = JSON.stringify(reps);

      localStorage.sales_product = JSON.stringify(filters.product);

      let customer_classes = [];
      _.forEach(filters.customer_classes, m=>{
        customer_classes.push(m.id);
      })
      localStorage.sales_customer_classes = JSON.stringify(customer_classes);

      this.setFilters();
      this.fetchData();
    },
    formatQty(value) {
      const parsed = Number(value || 0);
      return Math.round(parsed * 100) / 100;
    },
    openFilterDialog(){
      this.reportFilterVisible = true;
    },
    handleToggleZeroTotalCases() {
      this.toggleLoading = true;
    },
    handleZeroTotalCasesChange(value) {
      setTimeout(() => {
        this.appliedShowZeroTotalCases = value;
        localStorage.sales_showZeroTotalCases = value;
        this.toggleLoading = false;
      }, 250);
    },
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    handleScroll() {
      this.showScrollTop = window.scrollY > 300;
    },
    closeFilterDialog(){
      this.reportFilterVisible=false;
    },
    downloadExcel() {
      const rows = [];
      let totalQty = 0;
      let totalCases = 0;

      this.groupedProducts.forEach((product) => {
        const productCases = Number(product.total_qty_9l || 0);
        totalQty += Number(product.total_qty || 0);
        totalCases += Number(productCases || 0);

        // Ligne produit
        rows.push({
          'Produit': product.product_name,
          'SKU': product.sku,
          'Fournisseur': product.provider_name,
          'UVC': this.formatQty(product.uvc),
          'Format': product.format || '',
          'Volume (ml)': this.formatQty(product.volume),
          'No client': '',
          'Client': '',
          'Quantité': this.formatQty(product.total_qty),
          'Nb caisses': productCases,
        });

        // Lignes clients
        product.customers.forEach((customer) => {
          rows.push({
            'Produit': '',
            'SKU': '',
            'Fournisseur': '',
            'UVC': '',
            'Format': '',
            'Volume (ml)': '',
            'No client': customer.customer_id,
            'Client': customer.customer_name,
            'Quantité': this.formatQty(customer.total_qty),
            'Nb caisses': this.formatQty(customer.total_qty_9l),
          });
        });
      });

      // Ligne totaux
      rows.push({
        'Produit': 'TOTAL',
        'SKU': '',
        'Fournisseur': '',
        'UVC': '',
        'Format': '',
        'Volume (ml)': '',
        'No client': '',
        'Client': '',
        'Quantité': Math.round(totalQty * 100) / 100,
        'Nb caisses': Math.round(totalCases * 100) / 100,
      });

      const ws = XLSX.utils.json_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Ventes par client-produit');
      const buf = XLSX.write(wb, { type: 'array', bookType: 'xlsx' });
      const filename = `ventes-client-produit-${moment().format('YYYY-MM-DD')}.xlsx`;
      saveAs(new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }), filename);
    },
    prepareBuildRequest () {
      let filters = _.cloneDeep(this.filters);
      if(filters.startDate!=null){
        filters.startDate = moment(filters.startDate).format('YYYY-MM-DD Z');
      }
      if(filters.endDate!=null){
        filters.endDate = moment(filters.endDate).format('YYYY-MM-DD Z');
      }
      filters.productId = filters.product != null ? filters.product.id : undefined;
      delete filters.product;
      return filters;
    },
    fetchData(){
      this.loading = true;
      
      let filters = this.prepareBuildRequest();

      return salesAPI.getSummaryCustomerSalesByProduct(filters)
        .then(data=>{
          this.data = data;
          this.loading = false;
        }).catch(err=>{
          console.log(err);
          this.loading = false;
          this.$message.error('Une erreur système est survenue. Veuillez réessayer plus tard')
        })
    },
    setFilters(){

      if(localStorage.sales_range==null){
        localStorage.sales_range='MONTH';
      }
      this.filters.range=localStorage.sales_range;

      if(this.filters.range=='FISCAL_YEAR' && this.fiscalYearDate.startDate!=null && this.fiscalYearDate.endDate!=null){
        localStorage.sales_startDate = this.fiscalYearDate.startDate;
        localStorage.sales_endDate = this.fiscalYearDate.endDate;
      }else if(this.filters.range=='LAST_FISCAL_YEAR' && this.lastFiscalYearDate.startDate!=null && this.lastFiscalYearDate.endDate!=null){
        localStorage.sales_startDate = this.lastFiscalYearDate.startDate;
        localStorage.sales_endDate = this.lastFiscalYearDate.endDate;
      }else if(this.filters.range=='MONTH'){
        localStorage.sales_startDate = this.month.startDate;
        localStorage.sales_endDate = this.month.endDate;
      }else if(this.filters.range=='LAST_MONTH'){
        localStorage.sales_startDate = this.lastMonth.startDate;
        localStorage.sales_endDate = this.lastMonth.endDate;
      }else if(this.filters.range=='LAST_12_MONTHS'){
        localStorage.sales_startDate = moment().subtract(11, 'months').startOf('month');
        localStorage.sales_endDate = moment().endOf('month');
      }

      this.filters.startDate = localStorage.sales_startDate;
      this.filters.endDate = localStorage.sales_endDate;
 
      this.filters.customerId=localStorage.sales_customerId!='undefined' && localStorage.sales_customerId!=null  ? parseInt(localStorage.sales_customerId) : undefined;
      this.filters.providerId=localStorage.sales_providerId!='undefined' && localStorage.sales_providerId!=null  ? parseInt(localStorage.sales_providerId) : undefined;

      this.filters.reps=localStorage.sales_reps!=null ? JSON.parse(localStorage.sales_reps) : [];

      this.filters.product = localStorage.sales_product !=null ? JSON.parse(localStorage.sales_product) : null;

      this.filters.customer_classes=localStorage.sales_customer_classes!=null ? JSON.parse(localStorage.sales_customer_classes) : [];
      this.filters.inventories=localStorage.sales_inventories!=null ? JSON.parse(localStorage.sales_inventories) : [];

      this.applyStrictRepFilter();


    },
    applyStrictRepFilter() {
      if (this.isStrictFilteredByRep === true && this.isCurrentUserRep === true && !this.isCurrentUserAdmin && this.getCurrentUserId != null) {
        this.filters.reps = [this.getCurrentUserId];
        localStorage.sales_reps = JSON.stringify(this.filters.reps);
      }
    },
    ...mapActions('inventory',['fetchInventories']),
    ...mapActions('users',['fetchAdminUsers']),
    ...mapActions('controlData',['fetchCustomerClasses'])
  },
  mounted(){
    this.scrollHandler = () => this.handleScroll();
    window.addEventListener('scroll', this.scrollHandler);
  },
  beforeDestroy(){
    this.data = [];
    if (this.scrollHandler) {
      window.removeEventListener('scroll', this.scrollHandler);
    }
  },
  created(){
    this.loading = true;
    return Promise.all([
      this.fetchAdminUsers(),
      this.fetchInventories(),
      this.fetchCustomerClasses()])
        .then(()=> this.setFilters())
        .then(() => this.fetchData())
  }
}
</script>
<style lang="scss" scoped>
@import '../../../../../assets/scss/_variables';

@media print {
  body, html { margin-top:0%;
    font-size:0.8em;
     display:block;
     height:100%;
     width:100%;
     position:unset !important;
     background:none;
     overflow-x: hidden;overflow-y: auto;height:100%;width:100%;display:block;position:unset
   }
   .no-print{
   	display:none;
   }
   .el-card{
     border:none;
     width:100%;
   }

   @page {
     size: portrait;
   }


}
.title {
	font-size : 1.6em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:40px;
}

.controls{
	position:relative;
	float:right;
  display:flex;
  align-items:center;
  gap:8px;

	button{
		margin-left:20px;
	}
}

.sort-controls {
  clear: both;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  margin: 8px 0 12px 0;
}

.sort-label {
  font-size: 12px;
  color: #606266;
}

.toggle-zero-label {
  font-size: 12px;
}

::v-deep .fs-10 .el-table__cell {
  padding: 2px 0;
}

.product-name,
.product-sku {
  line-height: 1.5;
  margin: 0;
}

.product-name {
  font-size: 14px;
  font-weight: bold;
}

.product-sku {
  font-size: 12px;
}

.product-provider {
  font-size: 12px;
  color: #606266;
}

.month-value-cell {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.month-value {
  font-size: 12px;
  font-weight: 500;
}

.total-cases-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.total-value {
  font-weight: bold;
  font-size: 14px;
}


.customer-summary-table {
  margin: 4px 0;
}

.expand-content {
  padding: 20px;
}

::v-deep .scroll-to-top-btn {
  position: fixed !important;
  bottom: 30px !important;
  right: 30px !important;
  z-index: 1000 !important;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15) !important;
}


</style>
